/**
 * Whether the row's <tr> is registered as its sortable element.
 *
 * Not during a multi-row drag: the invisible proxy carries it then. And not
 * while the table is not editing (PSTUDIO-4452): the drag handle is only
 * rendered in edit mode, and without one dnd-kit makes the <tr> itself the
 * activator — role=button, tabindex=0, aria-disabled=true. It never removes
 * those when the handle comes back, so after any read-only spell (an import
 * lock, the publish lock) every row stayed a disabled button: announced as
 * one, a tab stop each, and not clickable for Playwright.
 */
export const rowIsSortableElement = ({
  editing,
  isMultiDrag,
  isPartOfMultiSelection,
}: {
  editing: boolean;
  isMultiDrag: boolean;
  isPartOfMultiSelection: boolean;
}): boolean => editing && !isMultiDrag && !isPartOfMultiSelection;
